<template>
  <div class="input">
    <input
      class="engine"
      type="text"
      v-model="search"
      @input="onChange"
      @keydown.down="onArrowDown(false)"
      @keydown.up="onArrowUp"
      @keydown.enter="setResult(finalResult)"
      @keydown.esc="cleanSearch"
      :placeholder="placeholder"
    />
    <ul v-if="inputVisibility" class="autocomplete-results">
      <li v-if="stateFound == 'not found'" class="autocomplete-result">
        Not Found!
      </li>
      <li v-if="stateFound == 'invalid'" class="autocomplete-result">
        Invalid ID!
      </li>
      <li
        v-else
        v-for="(result, idx) in results"
        :key="idx"
        @click="setResult(result)"
        class="autocomplete-result"
        :class="{
          'is-active': idx === arrowCounter,
          'nearby-color':
            stateFound == 'nearby' || stateFound == 'locationmatch',
          'exact-color': stateFound == 'exact',
        }"
      >
        <span v-html="result"></span>
      </li>
    </ul>
  </div>
</template>
<script>
import axios from "axios";
import { buildManhattanPlot } from '@/plots/manhattan/scatter.js';


export default {
  name: "Engine",
  data() {
    return {
      items: [],
      search: "",
      results: [],
      arrowCounter: -1,
      stateFound: "",
      isFound: false,
      finalResult: null,
      isSet: false,
      placeholder: "Search for the variant",
    };
  },
  computed: {
    inputVisibility() {
      return this.search.length > 0 ? true : false;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    axiosHandler() {
      const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_ROOT_API,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('ages_hms_access_token')}`,
        },
      });
      return axiosInstance
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.arrowCounter = -1;
        this.cleanSearch();
        this.finalResult = null;
      }
    },
    cleanSearch() {
      this.search = "";
    },
    getFormatSearch() {
      let search = this.search;
      search = search.trim().replace(/[-\.:]/g, "_");
      search = search.replace(/\s/g, "");
      if (search.startsWith("r") || search.startsWith("R")) {
        search = search.toLowerCase();
      } else {
        search = search.toUpperCase();
      }
      return search;
    },
    async onChange() {
      const headers = {
        "Content-Type": "text/plain",
      };
      let search = this.getFormatSearch();
      let manhContainer = document.getElementById("manhattan-plot");
      this.axiosHandler()
        .post(
          `/api/search-id-rsid`,
          {
            prefix: search
          }
        )
        .then((response) => {
          let flag = response.data.flag;
          let results = [];
          this.stateFound = flag;
          if (flag == "match") {
            if (this.search.toLowerCase().startsWith("rs")) {
              results = response.data.id_rsid[0];
              results = [`${results[1][0]} (${results[0]})`];
            } else {
              results = response.data.id_rsid[0];
              results = [`${results[0]} (${results[1].join(", ")})`];
            }

          } else if (flag == "nearby" || flag == "locationmatch") {
            let ids = response.data.id_rsid;
            ids.forEach((id_rsid) => {
              let id = id_rsid[0];
              let rs_id = id_rsid[1];
              if (rs_id.length > 0) {
                results.push(`${id} (${rs_id.join(", ")})`);
              } else {
                results.push(`${id}`);
              }
            });
          }
          if (flag == "match" || flag == "locationmatch") {
            const getCommonLength = (given, match) => {
              for (let i = 0; i < Math.min(given.length, match.length); i++) {
                if (given[i] !== match[i]) {
                  return i;
                }
              }
              return Math.min(given.length, match.length);
            };
            let search = this.getFormatSearch();
            let boldLen = getCommonLength(search, results[0]);
            results = results.map((value) => {
              return `<b>${value.substring(0, boldLen)}</b>${value.substring(
                boldLen
              )}`;
            });
          }
          this.results = results;
          this.onArrowDown(true);
        });
    },
    setResult(result) {
      if (result == null) {
        return;
      }
      result = result.replace(/(<([^>]+)>)/gi, "");
      this.search = "";
      let ID = result.split(" (")[0];
      this.$store.state.id = ID;
      this.$router.push(`/variant/${ID}`);
    },
    onArrowDown(setFirst) {
      if (setFirst) {
        this.arrowCounter = 0;
      } else {
        if (this.arrowCounter < this.results.length - 1) {
          this.arrowCounter = this.arrowCounter + 1;
        } else {
          this.arrowCounter = 0;
        }
      }
      this.isOpen = true;
      this.finalResult = this.results[this.arrowCounter];
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      } else {
        this.arrowCounter = this.results.length - 1;
      }
      this.isOpen = true;
      this.finalResult = this.results[this.arrowCounter];
    },
  },
};
</script>

<style>
.input {
  width: 945px;
  display: flex;
  justify-content: center;
}

.engine input {
  width: 945px;
  outline: none;
  border: 1.5px solid #A51C30;
  border-radius: 5px;
  padding: 9px 8px;
  font-family: 'Ubuntu';
  font-size: 0.9rem;
  transition: 300ms;
}

.engine-small input {
  width: 305px;
  display: flex;
  justify-content: left !important;
  outline: none;
  border: 1.5px solid #A51C30;
  border-radius: 5px;
  padding: 9px 8px;
  height: 35px;
  font-family: 'Ubuntu';
  font-size: 12px;
  transition: 300ms;
}

.engine-small:after {
  background-color: #A51C30;
  padding-top: 10px;
  padding-left: 13px;
  padding-right: 10px;
  color: white;
  position: relative;
  right: 6px;
  top: 0px;
  height: 23px;
  z-index: 1;
  width: 98px;
  font-size: 12px;
  border: 1px solid #A51C30;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  content: "RSID / ID GRCh37";
}

/* .engine:hover input {
  box-shadow: 0 0 15px rgba(10, 66, 221, 0.3);
  transition: 300ms;
} */
.engine:after {
  background-color: #A51C30;
  padding-top: 13px;
  padding-left: 13px;
  padding-right: 10px;
  color: white;
  position: relative;
  right: 3px;
  top: 0px;
  height: 31px;
  z-index: 1;
  width: 154px;
  border: 1px solid #A51C30;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  content: "RSID / ID GRCh37";
}

.autocomplete-results {
  background-color: white;
  z-index: 999999;
  max-height: 150px;
  overflow-y: scroll;
  position: absolute;
  width: 940px;
  border: 1.2px solid #a51c31aa;
  padding: 5px 2px;
  margin-top: 50px;
  border-radius: 5px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}
.autocomplete-result {
  z-index: 99999;
  word-wrap: break-word;
  list-style-type: none;
  padding: 5px;
  font-size: 0.8rem;
  border-radius: 5px;
  font-size: 0.93rem;
  cursor: pointer;
  margin: 3px;
}
.engine-small > .autocomplete-results {
  background-color: white;
  z-index: 99999;
  width: 421px;
  border: 1.2px solid #a51c31aa;
  padding: 5px;
  margin-top: 38px;
  border-radius: 4px;
}
.engine-small .autocomplete-results > .autocomplete-result {
  z-index: 99999;
  word-wrap: break-word;
  list-style-type: none;
  padding: 5px;
  border-radius: 5px;
  font-size: 0.7rem;
  cursor: pointer;
}
.autocomplete-result:hover,
.autocomplete-result.is-active {
  background-color: #a51c311c;
}
.input {
  position: relative;
}
.engine-small.input {
  width: 500px;
}
.not-found {
  position: absolute;
  background-color: rgba(255, 0, 0, 0.6);
  padding: 0.5rem;
  color: white;
  border-radius: 15px;
  font-size: 13px;
  left: 152px;
  top: 230px;
  transition: 300ms;
}
.nearby-color {
  color: rgb(90, 90, 90);
}
.exact-color {
  color: black;
}
</style>
